import React from 'react';
import './WelcomeScreen.css';

interface WelcomeScreenProps {
  onBegin: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onBegin }) => {
  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <div className="title-section">
          <h1 className="game-title-large">Beats of the Ancients</h1>
          <p className="game-subtitle-large">
            An ancient civilization left behind mysterious musical machines...
          </p>
        </div>
        
        <div className="story-preview">
          <p className="flavor-text">
            Deep beneath the archaeological site, you've discovered fragments of a lost musical technology. 
            These glowing artifacts seem to contain pieces of baroque compositions, waiting to be reconstructed.
          </p>
        </div>
        
        <div className="action-section">
          <button 
            className="begin-journey-btn"
            onClick={onBegin}
          >
            Begin Journey
          </button>
        </div>
        
        <div className="background-effects">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;